var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasswordVisibleDarkgrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_8339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_8339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 41.431C19.7467 41.4406 14.6178 39.8325 10.3104 36.8252C6.09802 33.8984 2.84945 29.7867 0.976562 25.0114C2.84963 20.2367 6.0982 16.1256 10.3104 13.1993C14.6223 10.2009 19.7485 8.59375 25.0004 8.59375C30.2523 8.59375 35.3785 10.2009 39.6903 13.1993C43.9022 16.1258 47.1505 20.2368 49.0234 25.0114C47.1508 29.7866 43.9025 33.8983 39.6903 36.8252C35.3827 39.8326 30.2536 41.4408 25 41.431ZM25 14.067C18.9793 14.067 14.0812 18.9767 14.0812 25.0114C14.0812 31.0462 18.9793 35.9578 25 35.9578C31.0207 35.9578 35.9208 31.0473 35.9208 25.0114C35.9208 18.9756 31.0218 14.067 25 14.067ZM25 31.5801C23.7005 31.5829 22.4293 31.2002 21.3474 30.4803C20.2655 29.7604 19.4214 28.7357 18.9221 27.5359C18.4228 26.3361 18.2906 25.0152 18.5423 23.7403C18.7941 22.4654 19.4183 21.2938 20.3362 20.3738C21.254 19.4538 22.4241 18.8268 23.6985 18.5721C24.9728 18.3174 26.294 18.4465 27.495 18.943C28.6959 19.4395 29.7226 20.2812 30.445 21.3614C31.1674 22.4416 31.5531 23.7119 31.5533 25.0114C31.5537 26.751 30.8638 28.4196 29.6352 29.6511C28.4066 30.8826 26.7396 31.5763 25 31.5801Z",
    fill: "#707070"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordVisibleDarkgrey);
export default __webpack_public_path__ + "static/media/password_visible_darkgrey.d89a5cb92e49925a60a84e5171fe502c.svg";
export { ForwardRef as ReactComponent };